import { render, staticRenderFns } from "./CRUDTableStaff.vue?vue&type=template&id=1ab7acdd&scoped=true"
import script from "./CRUDTableStaff.vue?vue&type=script&lang=js"
export * from "./CRUDTableStaff.vue?vue&type=script&lang=js"
import style0 from "./CRUDTableStaff.vue?vue&type=style&index=0&id=1ab7acdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab7acdd",
  null
  
)

export default component.exports